import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { withApollo } from 'react-apollo';
import { Modal } from 'antd';
import { map, get, includes, filter, head, some, isEmpty, last } from 'lodash';
import OrderItemsDetailTab from '../../src/components/sections/Orders/OrderItemsDetailTabs';
import OrderResume from '../../src/components/sections/Orders/OrderResume';
import OrderActions from '../../src/components/sections/Orders/OrderActions';
import OrderStatus from '../../src/components/sections/Orders/OrderStatus';
import PubSub from 'services/PubSub';
import QueryOrderItems from '../../src/components/graphql/getOrderItems';
import ModuleAccessLogger from '../../src/components/graphql/ModuleAccessLogger';
import OrderCallHistory from '../../src/components/sections/OrderCallHistory';
import RegisterCall from '../../src/components/sections/RegisterCall';
import OrderEventsFeed from '../../src/components/firebase/OrderEventsFeed';
import OrderAuditManagement from '../../src/components/firebase/OrderAuditManagement';
import { cleanOrderId, hasPermissionBySalesChannel } from '../../src/utils/misc';
import { DrawerHeader, Drawer, Loading, FlexContainer, If, Column, Text, Button, HasPermissions, Main, Container, NotFound, Row, IconContainer, Icon, SpaceBetween, MobileWrapper, IsMobileWrapper } from '../../src/components/common';
import { OrderProductDetail } from '../../src/components/sections/Orders';
import withFirebase from '../../src/hoc/withFirebase';
import '../audit-monitor.css';
import { withNavigation } from '../../src/hoc';
import SEND_ORDER_INVOICE_MAIL from '../../src/components/graphql/sendOrderInvoiceMail';
import ModalBodyBagging from './ModalBodyBagging';
import BaggingImagesDrawer from './BaggingImagesDrawer';
import { BLUE, RED } from '../../src/utils/colors';
import AuditOrderDrawer from '../../src/features/audit-monitor/components/auditOrderDrawer';
import { useAuditDrawer } from '../../src/features/audit-monitor/hooks/useAuditDrawer';

const MonitorLoadingComponent = () => (
    <FlexContainer grow={1} align='center' justify='center'>
        <Loading loading />
    </FlexContainer>
);

const BipickingIcon = ({ orderbipicking }) => {
    if (!orderbipicking) return null;

    return <Row>
        <Icon name='bipicking-a' size={22} color={BLUE} />
        <Icon name='bipicking-b' size={22} color={RED} style={{ margin: '0px 6px 0px -4px' }}/>
    </Row>
  };

const OrderHeaderInfo = ({ orderId, session }) => (
    <IsMobileWrapper>
        {({ isMobile }) => {
            const containerStyles = isMobile ? { pL: 27, pY: 7, backgroundColor: '#f4f4f4', position: 'fixed', width: '100%', zIndex: '1' } : { direction: 'row', align: 'center', mL: 10 };
            const fontSize = isMobile ? 16 : 20;
            return (
                <OrderStatus orderId={orderId} session={session} >
                    {({ lastKnownStatus, data, loading }) => (
                        <>
                            { isMobile && <div style={{ height: '35px' }} /> }
                            <FlexContainer {...containerStyles} gap={5}>
                                <Text size={fontSize} strong text={`${data.idStore}-${cleanOrderId(orderId)}`} />
                                <BipickingIcon orderbipicking={get(data, 'assignInfo.ordersBipicking',null)} />
                                <Loading loading={(get(lastKnownStatus, 'code') === '-1' && loading)}>
                                    <Text text={`order_status.${lastKnownStatus.label}`} color='#1fa02e' size={fontSize} className='colorStatus' />
                                </Loading>
                            </FlexContainer>
                        </>
                    )}
                </OrderStatus>
            );
        }}
    </IsMobileWrapper>
);

const OrderDetailLayout = ({ orderId, children, toggleDrawerOptions, session, ...props }) => {
    const [visibleModal, setVisibleModal] = useState(false);

    useEffect(() => {
        PubSub.dispatch('SET_CENTER_HEADER', (layoutProps) => leftHeader({ lastKnownStatus: 0, loading: true, ...props }));
        PubSub.dispatch('SET_RIGHT_HEADER', (layoutProps) => rightHeader({ ...props }));
        return () => {
            PubSub.dispatch('SET_RIGHT_HEADER', () => '');
            PubSub.dispatch('SET_CENTER_HEADER', () => '');
        };
    }, [orderId]);

    const leftHeader = ({ pathname, ...props }) => (
        <MobileWrapper hide showDesktop>
            <OrderHeaderInfo orderId={orderId} session={session} />
        </MobileWrapper>
    );

    const rightHeader = ({ pathname, status, ...props }) => (
        <MobileWrapper hide showDesktop>
            <FlexContainer align='center' justify='flex-end'>
                <OrderStatus orderId={orderId} session={session} >
                    {({ lastKnownStatus, data }) => {
                        const statusCode = parseInt(get(lastKnownStatus, 'code', 0));
                        return (
                            <>
                                { ((statusCode >= 4) && !includes([7], statusCode)) &&
                                    <Button
                                        onClick={() => window.open(`/order-labels/${orderId}`, '_blank')}
                                        text='Etiquetas'
                                        link
                                    />
                                }
                                <HasPermissions to={['order-detail-page:edit-bagging']}>
                                    <Button
                                        disabled={!(statusCode === 6)}
                                        onClick={() => setVisibleModal(true)}
                                        text='Embolsar'
                                    />
                                </HasPermissions>
                            </>
                        );
                    }}
                </OrderStatus>
                <HasPermissions to={['order-detail-page:print-order-detail-page']}>
                    <Button
                        onClick={() => window.open(`/order-list/${orderId}`, '_blank')}
                        text='nav.actions.order-options.print'
                        left={10}
                        right={10}
                    />
                </HasPermissions>
                <Button secondary text='nav.actions.order-options' onClick={() => toggleDrawerOptions()} />
            </FlexContainer>
        </MobileWrapper>
    );

    return (
        <OrderAuditManagement orderId={orderId}>
            <OrderEventsFeed orderId={orderId}>
                <Container direction='column' grow={1} shrink={0}>
                    <Main withFooter>
                        <OrderStatus orderId={orderId}>
                            {({ lastKnownStatus, data, loading, ts }) => (
                                <>
                                <Loading loading={!get(lastKnownStatus, 'code') || loading}>
                                    { children({ lastKnownStatus, data, loading, ts })}
                                </Loading>
                                <ModalBodyBagging orderId={orderId} visibleModal={visibleModal} toggleModal={() => setVisibleModal(!visibleModal)} salesChannelId={get(data, 'salesChannelId', "")}/>
                                </>
                            )}
                        </OrderStatus>
                    </Main>
                </Container>
            </OrderEventsFeed>

        </OrderAuditManagement>
    );
};

OrderDetailLayout.propTypes = {
    orderId: PropTypes.string,
    children: PropTypes.func,
    toggleDrawerOptions: PropTypes.func
};

const OrdersDetail = ({ client, userInfo, session, firebase, match }) => {
    const [drawerItemDetail, setDrawerItemDetail] = useState(false);
    const [drawerOptionsOpened, setDrawerOptionsOpened] = useState(false);
    const [selectedItem, setSelectedItem] = useState({});
    const [baggingImagesDrawerOpened, setBaggingImagesDrawerOpened] = useState(false);
    const [mailOrderInvoicedDrawerOpened, setMailOrderInvoicedDrawerOpened] = useState(false);
    const [mailOrderInvoicedHistoryDrawerOpened, setMailOrderInvoicedHistoryDrawerOpened] = useState(false);
    const [registerCallDrawer, setRegisterCallDrawer] = useState(false);
    const [callHistoryDrawer, setCallHistoryDrawer] = useState(false);
    const [callHistoryType, setCallHistoryType] = useState(null);
    const [visible, setVisible] = useState(false);
    const [sendingEmail, setSendingEmail] = useState(false);
    const [iconName, setIconName] = useState(null);
    const [textInfo, setTextInfo] = useState(null);
    const [mobileOptions, setMobileOptions] = useState(false);
    const {
        drawerOpened: auditDrawerOpened,
        selectedOrder: selectedAuditOrder,
        onClickCard,
        toggleDrawer: toggleAuditDrawer
    } = useAuditDrawer();
    const orderId = match.params.id;

    const buttons = [
        {
            id: 1,
            name: 'Reenviar mail',
            onClick: async () => {
                try {
                    setSendingEmail(true);
                    const { data: { sendOrderInvoiceMail: { internalCode } } } = await client.mutate({
                        mutation: SEND_ORDER_INVOICE_MAIL,
                        variables: { orderId }
                    });

                    internalCode === '200'
                        ? confirmationModal('check', `Correo enviado con éxito al cliente orden nro: ${orderId}`)
                        : confirmationModal('trash', 'Ha ocurrido un error!');
                } catch (e) {
                    console.log('Error >>', e);
                    confirmationModal('trash', 'Ha ocurrido un error!');
                } finally {
                    setSendingEmail(false);
                }
            }
        },
        {
            id: 2,
            name: 'Descargar PDF',
            onClick: () => {
                const baseURL = 'http://reportes-backoffice.smdigital.cl/api/v1/report';
                window.open(`${baseURL}?file=${orderId}.pdf&kind=stockControReport&store=attachment-transactional-mail&`);
            }
        }
    ];

    const closeDrawerItemDetail = () => setDrawerItemDetail(false);

    const toggleItemDetailModal = (row, rowIndex) => {
        setDrawerItemDetail(!drawerItemDetail);
        setSelectedItem(row);
    };

    const handleAuditClick = (orderData) => {
        const auditOrderData = {
            id: orderId,
            idStore: get(orderData, 'idStore'),
            salesChannel: {
                id: get(orderData, 'salesChannelId')
            },
            ...orderData
        };

        onClickCard(auditOrderData);

    };

    const toggleDrawerOptions = () => setDrawerOptionsOpened(!drawerOptionsOpened);

    const toggleMailOrderInvoiced = ({
        history = mailOrderInvoicedHistoryDrawerOpened,
        emailOrder = mailOrderInvoicedDrawerOpened
    }) => {
        setMailOrderInvoicedDrawerOpened(emailOrder);
        setMailOrderInvoicedHistoryDrawerOpened(history);
    };

    const toggleRegisterCallDrawer = () => {
        setRegisterCallDrawer(!registerCallDrawer);
        setDrawerOptionsOpened(false);
    };

    const toggleCallHistoryDrawer = (callHistoryType) => {
        setCallHistoryType(callHistoryType);
        setCallHistoryDrawer(!callHistoryDrawer);
        setDrawerOptionsOpened(false);
    };
    const toggleBaggingImagesDrawer = () => {
        setBaggingImagesDrawerOpened(!baggingImagesDrawerOpened);
    };

    const showPicking = (status) => {
        const { code = 0 } = status;
        const beetrackStatus = ['50', '51', '53', '54', '55', '56', '57', '58', '59', '60'];
        const shouldShowPicking = includes([ '4', '5', '6', '7', '8', '9', '30', '31', '32', '33', '34', '40', '41',
            ...beetrackStatus
        ], String(code));
        // console.log(status, shouldShowPicking)
        return shouldShowPicking;
    };

    const getDrawerProductDetailTitle = (item) => {
        const status = get(item, 'status', get(item, 'picking.status'));
        if (['PICKED'].includes(status)) return 'Pickeado';
        if (['PARTIAL', 'PARTIAL_ACCEPTED'].includes(status)) return 'Faltante parcial';
        if (['ADDED_BY_CLIENT'].includes(status)) return 'Agregado nuevo';
        if (['FREE_PICKING', 'FREE_PICKING_ACCEPTED'].includes(status)) return 'Picking Compuesto';
        if (
            [
                'REPLACE',
                'SUBSTITUTE_CONFIRMED',
                'REPICKING_SUBSTITUTE_CONFIRMED'
            ].includes(status)
        ) return 'Sustituido';
        if (['OUT_STOCK', 'OUT_STOCK_ACCEPTED'].includes(status)) return 'Sin stock';
        if (includes(['UNPICK_ADDED_BY_CLIENT'], status)) return 'Eliminado Cliente';
        if (includes(['UNPICK_BY_STORE'], status)) return 'Eliminado Sala';
        return `Sin Pickear`;
    };

    const productDetailResolver = (orderItems) => {
        const isUnpickedFromStore = filter(
            get(orderItems, 'removedItems', []), ({ id, ...more }) =>
                id === get(selectedItem, 'id') && get(more, 'status', get(more, 'picking.status')) === 'UNPICK_BY_STORE'
        );
        const statusResolver = () => {
            if (!isEmpty(isUnpickedFromStore)) return 'UNPICK_BY_STORE';
            const wasAdded = some(
                get(orderItems, 'outStocksWithoutAudit', []), ({ id }) => id === get(selectedItem, 'id', '')
            );
            return wasAdded ? 'OUT_STOCK_ACCEPTED' : get(selectedItem, 'status', get(selectedItem, 'picking.status'));
        };
        if (includes(
            ['UNPICK_ADDED_BY_CLIENT', 'ADDED_BY_CLIENT', 'UNPICK_BY_STORE'],
            get(selectedItem, 'status', get(selectedItem, 'picking.status'))
        )) return { ...selectedItem, status: statusResolver() };
        if (!isEmpty(isUnpickedFromStore)) return head(isUnpickedFromStore);
        const result = head(filter(
            get(orderItems, 'items', selectedItem),
            ({ id }) => id === get(selectedItem, 'id')
        ));

        return result;
    };

    const confirmationModal = (iconName = '', textInfo = '') => {
        setIconName(iconName);
        setTextInfo(textInfo);
        setVisible(!visible);
    };

    const modalInfo = () => (
        <Modal
            closable={false}
            title={null}
            visible={visible}
            footer={null}
            zIndex='1000000'
        >
            <FlexContainer margin={30} align='center' direction='column'>
                <IconContainer color='#f38630'>
                    <Icon name={iconName} color='#ffffff' size={46.8} />
                </IconContainer>
                <FlexContainer mY={30} direction='column' align='center'>
                    <Row justify='center'>
                        <Text text={textInfo} />
                    </Row>
                </FlexContainer>
                <FlexContainer justify='flex-end' style={{ width: '100%' }}>
                    <Button
                        text='btn.action.close'
                        style={{ width: '100px' }}
                        onClick={confirmationModal}
                    />
                </FlexContainer>
            </FlexContainer>
        </Modal>
    );

    return (
        <HasPermissions
            to={['order-detail-page:view']}
            otherwise={<NotFound firstTextLine='Página no encontrada' style={{ minHeight: '90vh' }} />}
        >
            <ModuleAccessLogger module='Detalle de Pedido' />
            <OrderDetailLayout
                orderId={orderId}
                toggleDrawerOptions={toggleDrawerOptions}
                session={session}
            >
                {({ loading, data, lastKnownStatus, ts, networkStatus }) => {
                    const lastKnownStatusCode = get(lastKnownStatus, 'code', 0);
                    const salesChannelId = get(data, 'salesChannelId');

                    return (
                        <Loading loading={networkStatus === 6 ? false : (loading || sendingEmail)} Component={MonitorLoadingComponent}>
                            <If condition={get(data, 'id') && hasPermissionBySalesChannel(get(session, 'salesChannels', []), get(data, 'salesChannelId'))}
                                then={(
                                    <>
                                        <MobileWrapper>
                                            <OrderHeaderInfo orderId={orderId} session={session} />
                                        </MobileWrapper>
                                        <OrderResume
                                            ts={showPicking(lastKnownStatus)}
                                            data={data}
                                            withPicking={showPicking(lastKnownStatus)}
                                            inPicking={includes(['3'], get(lastKnownStatus, 'code'))}
                                            onClickCallHistory={toggleCallHistoryDrawer}
                                            lastKnownStatusCode={lastKnownStatusCode}

                                        />
                                        <OrderItemsDetailTab
                                            ts={showPicking(lastKnownStatus)}
                                            orderId={orderId}
                                            salesChannelId={salesChannelId}
                                            onRowClick={toggleItemDetailModal}
                                            inPicking={includes(['3', '7'], get(lastKnownStatus, 'code', lastKnownStatus))}
                                            withPicking={isEmpty(get(data, 'assignInfo.items')) ? false : showPicking(lastKnownStatus)}
                                            lastKnownStatus={lastKnownStatus}
                                            // withPicking={this._showPicking(lastKnownStatus)}
                                        />
                                        <MobileWrapper>
                                            <Modal visible={mobileOptions} footer={null} onCancel={() => setMobileOptions(false)}>
                                                <FlexContainer mT={30} direction='column'>
                                                    <OrderActions
                                                        orderId={orderId}
                                                        lastKnownStatus={lastKnownStatus}
                                                        {...data}
                                                    />
                                                </FlexContainer>
                                            </Modal>
                                            <FlexContainer fixedHeight={60}>
                                                <FlexContainer
                                                    fixedHeight={70}
                                                    position='fixed'
                                                    backgroundColor='#ffffff'
                                                    padding={20}
                                                    style={{ bottom: 0, minWidth: '100%', borderTop: '1px solid #eaeaea' }}
                                                    zIndex='3'
                                                >
                                                    <Button text='Opciones' onClick={() => setMobileOptions(true)} />
                                                </FlexContainer>
                                            </FlexContainer>
                                        </MobileWrapper>
                                        <QueryOrderItems variables={{ id: orderId }} withPicking={showPicking(lastKnownStatus)}>
                                            {({ data: orderItems, loading }) => {
                                                const item = productDetailResolver(orderItems);
                                                return (
                                                    <Drawer
                                                        values={['40%', '40%', '100%']}
                                                        visible={drawerItemDetail}
                                                        maskClosable
                                                        onClose={closeDrawerItemDetail}
                                                    >
                                                        { drawerItemDetail && (
                                                            <Column>
                                                                <DrawerHeader title={getDrawerProductDetailTitle(item)} onClose={closeDrawerItemDetail} />
                                                                <OrderProductDetail
                                                                    idOrder={orderId}
                                                                    withPicking={showPicking(lastKnownStatus)}
                                                                    pickingStatus={lastKnownStatusCode}
                                                                    pickingTime={get(data, 'pickingTime', {})}
                                                                    data={productDetailResolver(orderItems)}
                                                                    loading={loading}
                                                                    onClose={closeDrawerItemDetail}
                                                                    items={get(orderItems, 'items')}
                                                                    session={session}
                                                                />
                                                            </Column>
                                                        )}
                                                    </Drawer>
                                                );
                                            }}
                                        </QueryOrderItems>
                                        <Drawer
                                            values={['25%', '25%', '100%']}
                                            title={<Text size={16} text='nav.actions.order-options' semibold />}
                                            closable
                                            visible={drawerOptionsOpened}
                                            onClose={toggleDrawerOptions}>
                                            <OrderActions
                                                onClose={toggleDrawerOptions}
                                                onClickOrderComments={toggleRegisterCallDrawer}
                                                onClickAudit={() => handleAuditClick(data)}
                                                onClickCallHistory={toggleCallHistoryDrawer}
                                                toggleAuditDrawer={() => handleAuditClick(data)}
                                                toggleMailOrderInvoiced={(historyMode) => toggleMailOrderInvoiced(historyMode)}
                                                orderId={orderId}
                                                lastKnownStatus={lastKnownStatus}
                                                toggleBaggingImagesDrawer={toggleBaggingImagesDrawer}
                                                {...data}
                                            />
                                        </Drawer>
                                        <AuditOrderDrawer
                                            visible={auditDrawerOpened}
                                            selectedOrder={selectedAuditOrder}
                                            userInfo={userInfo}
                                            onClose={toggleAuditDrawer}
                                            refetch={()=>{}}
                                            isAudit={false}
                                        />

                                        <Drawer
                                            values={['25%', '25%%', '100%']}
                                            title='Mail facturado'
                                            closable
                                            visible={mailOrderInvoicedDrawerOpened || mailOrderInvoicedHistoryDrawerOpened}
                                            onClose={() => toggleMailOrderInvoiced({ history: false, emailOrder: false })}
                                        >
                                            <FlexContainer flex={1} direction='column'>
                                                { map(buttons, ({ name, onClick }, index) => (
                                                    <Button
                                                        key={index}
                                                        onClick={() => onClick(orderId)}
                                                        top={6}
                                                        bottom={6}
                                                        secondary
                                                        text={name}
                                                    />
                                                ))}
                                            </FlexContainer>
                                        </Drawer>
                                        <Drawer
                                            values={['25%', '25%', '100%']}
                                            title={<Text size={20} text='nav.actions.register-call' />}
                                            closable
                                            visible={registerCallDrawer}
                                            onClose={toggleRegisterCallDrawer}
                                        >
                                            <RegisterCall
                                                orderId={orderId}
                                                onClose={toggleRegisterCallDrawer}
                                                callHistoryType={callHistoryType}
                                                {...data}
                                            />
                                        </Drawer>
                                        <Drawer
                                            values={['65%', '75%', '100%']}
                                            title={
                                                <FlexContainer flex={1}>
                                                    <Column justify='center'>
                                                        <Text size={20} text={`nav.actions.${callHistoryType}`} />
                                                    </Column>
                                                    { includes(['call_history', 'logbook'], callHistoryType) && (
                                                        <HasPermissions to={['order-detail-page:register-call']}>
                                                            <Column align='flex-end' mR={56}>
                                                                <Button
                                                                    text='Registrar llamado'
                                                                    onClick={toggleRegisterCallDrawer}
                                                                    width='fit-content'
                                                                />
                                                            </Column>
                                                        </HasPermissions>
                                                    ) }
                                                </FlexContainer>
                                            }
                                            closable
                                            visible={callHistoryDrawer}
                                            onClose={toggleCallHistoryDrawer}
                                        >
                                            <OrderCallHistory
                                                callHistoryType={callHistoryType}
                                                orderId={orderId}
                                                firebase={firebase}
                                                isWhatsapp={get(data, 'isWhatsapp', false)}
                                            />
                                        </Drawer>
                                        <BaggingImagesDrawer visible={baggingImagesDrawerOpened} onClose={toggleBaggingImagesDrawer} images={get(data, 'assignInfo.baggingInfo.images')} />
                                    </>
                                )}
                                else={
                                    <NotFound
                                        firstTextLine='El pedido que buscas no existe.'
                                        secondTextLine='Revisa la dirección ingresada.'
                                        hasGoBack
                                    />
                                }
                            />
                        </Loading>
                    );
                }}
            </OrderDetailLayout>
            { modalInfo() }
        </HasPermissions>
    );
};

OrdersDetail.propTypes = {
    match: PropTypes.object,
    userInfo: PropTypes.object,
    items: PropTypes.array,
    client: PropTypes.object,
    session: PropTypes.object,
    firebase: PropTypes.object
};

export default withNavigation(withApollo(withFirebase(OrdersDetail)));